<template>
   <div class="contractors-manual-flow">
      <b-alert v-if="editError" show variant="danger" class="mb-3">
         {{ editError }}
      </b-alert>

      <div v-if="effectiveViewMode === VIEW_MODES.MAIN">
         <ContractorList
            @onAddNewContractor="handleAddNewContractor"
            @onEditContractor="handleEditContractor"
         />
      </div>

      <div v-else-if="effectiveViewMode === VIEW_MODES.ADD">
         <ContractorForm @onBack="backToDefaultView" @updatePage="updateData" />
      </div>

      <div v-else-if="effectiveViewMode === VIEW_MODES.EDIT">
         <ContractorForm
            :contractorId="selectedContractor.id"
            :initial-contractor="selectedContractor"
            edit
            @onBack="backToDefaultView"
            @updatePage="updateData"
         />
      </div>

      <div v-else-if="effectiveViewMode === VIEW_MODES.LOADING" class="loading-state">
         <b-spinner label="Loading contractor details" variant="primary" />
      </div>
   </div>
</template>

<script>
import ContractorList from './ContractorList.vue';
import ContractorForm from './ContractorForm.vue';

const VIEW_MODES = {
   MAIN: 'MAIN',
   ADD: 'ADD',
   EDIT: 'EDIT',
   LOADING: 'LOADING',
};

export default {
   name: 'ContractorsManualFlow',
   components: {ContractorForm, ContractorList},
   data() {
      return {
         viewMode: VIEW_MODES.MAIN,
         selectedContractor: null,
         isEdited: false,
         editError: '',
      };
   },
   computed: {
      VIEW_MODES() {
         return VIEW_MODES;
      },
      contractorCount() {
         return (this.$store.getters['contractors/manualVendors'] || []).length;
      },
      effectiveViewMode() {
         if (this.viewMode === VIEW_MODES.MAIN && this.contractorCount === 0) {
            return VIEW_MODES.ADD;
         }
         return this.viewMode;
      },
   },

   methods: {
      async updateData(isEdited) {
         this.isEdited = isEdited;
      },

      backToDefaultView() {
         this.editError = '';
         this.viewMode = VIEW_MODES.MAIN;
         this.selectedContractor = null;
      },

      handleAddNewContractor() {
         this.editError = '';
         this.selectedContractor = null;
         this.viewMode = VIEW_MODES.ADD;
      },

      async handleEditContractor(contractor) {
         if (!contractor || !contractor.id) {
            return;
         }

         this.editError = '';
         this.selectedContractor = null;
         this.viewMode = VIEW_MODES.LOADING;

         try {
            const [loadedContractor, files] = await Promise.all([
               this.$store.dispatch('contractors/loadManualVendorDetails', {
                  vendorId: contractor.id,
               }),
               this.$store.dispatch('contractors/loadContractFiles', {
                  contractorId: contractor.id,
               }),
            ]);

            this.selectedContractor = {
               ...loadedContractor,
               uploadFiles: files || [],
            };
            this.viewMode = VIEW_MODES.EDIT;
         } catch (error) {
            this.selectedContractor = null;
            this.viewMode = VIEW_MODES.MAIN;
            this.editError =
               error?.response?.data?.detail ||
               error?.response?.data?.message ||
               'Could not load contractor details. Please try again.';
         }
      },
   },
};
</script>

<style scoped lang="scss">
.cr-modal-content {
   padding: 0.5rem 0 0 0;
   color: #212529;
}

::v-deep .modal-dialog {
   max-width: 80%;
}

.add-contractor-modal-footer-wrapper {
   display: flex;
   justify-content: flex-end;
   align-items: center;
   width: 100%;
   padding-top: 0.75rem;
}

.segmented {
   display: inline-flex;
   background: #eeeeee;
   border-radius: 0.75rem;
   padding: 0.3125rem;
   box-shadow: inset 0 0 0 1px #e4e7ec;
}

.segmented .segment {
   background: transparent;
   font-size: 0.875rem;
   font-weight: 500;
   color: $secondary;
   width: 11.875rem;
}

.segmented .segment.active {
   background: #ffffff;
   color: $primary;
}

.action-button {
   font-size: 0.75rem;
}

.contractors-manual-flow {
   min-height: 31rem;
}

.loading-state {
   min-height: 31rem;
   display: flex;
   align-items: center;
   justify-content: center;
}
</style>
